import { TFunction } from 'i18next'
import { defaultNS } from 'locale/i18n'
import { useTranslation } from 'react-i18next'

const useCustomTranslation = (
  prefix = ''
): TFunction<'sandbox', string, 'sandbox'> => {
  const { t } = useTranslation(defaultNS, { keyPrefix: prefix })
  return t
}

export default useCustomTranslation
